import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, renderList as _renderList } from "vue"

const _hoisted_1 = {
  id: "event-presentation-component",
  class: "o-eventPresentation l-container l-bg-primary l-container-pageheader"
}
const _hoisted_2 = { class: "m-pageHeader" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "m-pageHeader__rimL" }, null, -1)
const _hoisted_4 = { class: "m-pageHeader__container has-sections" }
const _hoisted_5 = {
  class: "m-pageHeader__section has-sectionBlocks",
  "data-js": "seatmap-controls"
}
const _hoisted_6 = ["data-qa"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "a-block"
}
const _hoisted_15 = { class: "a-block__col" }
const _hoisted_16 = { class: "a-block__col" }
const _hoisted_17 = {
  key: 3,
  class: "a-block"
}
const _hoisted_18 = { class: "a-block__col" }
const _hoisted_19 = { class: "a-block__col" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "m-pageHeader__rimR" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "o-eventPresentation__data m-pageHeader__sectionBlock",
            "data-js": "event-presentation-data-container",
            "data-qa": _ctx.PerformanceQASelectors.EVENT_CARD_INFO
          }, [
            (_ctx.isMobile)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.displayModeState.seatmap.isSeatmapVisible)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.eventInformation.parentUrl)
                          ? (_openBlock(), _createElementBlock("h2", {
                              key: 0,
                              class: _normalizeClass(["m-pageHeader__mobile", {'-expanded': _ctx.displayModeState.seatmap.isMenuExpanded}])
                            }, [
                              _createElementVNode("a", {
                                href: _ctx.eventInformation.parentUrl
                              }, _toDisplayString(_ctx.eventName), 9, _hoisted_7)
                            ], 2))
                          : (_openBlock(), _createElementBlock("h2", {
                              key: 1,
                              class: _normalizeClass(["m-pageHeader__mobile", {'-expanded': _ctx.displayModeState.seatmap.isMenuExpanded}])
                            }, _toDisplayString(_ctx.eventName), 3))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.eventInformation.parentUrl)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [
                              _createElementVNode("a", {
                                href: _ctx.eventInformation.parentUrl
                              }, _toDisplayString(_ctx.eventName), 9, _hoisted_9)
                            ]))
                          : (_openBlock(), _createElementBlock("h2", _hoisted_10, _toDisplayString(_ctx.eventName), 1))
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.eventInformation.parentUrl)
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_11, [
                        _createElementVNode("a", {
                          href: _ctx.eventInformation.parentUrl
                        }, _toDisplayString(_ctx.eventName), 9, _hoisted_12)
                      ]))
                    : (_openBlock(), _createElementBlock("h1", _hoisted_13, _toDisplayString(_ctx.eventName), 1))
                ], 64)),
            (!_ctx.isEventVoucher(_ctx.eventInformation) && _ctx.shouldDisplayOptionalMenuContent())
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_IconComponent, {
                      "icon-id": _ctx.IconName.Location
                    }, null, 8, ["icon-id"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.eventLocationInformation), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEventVoucher(_ctx.eventInformation))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_IconComponent, {
                      "icon-id": _ctx.IconName.Time
                    }, null, 8, ["icon-id"])
                  ], 512), [
                    [_vShow, _ctx.shouldDisplayOptionalMenuContent()]
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.eventFromDate)) + " ", 1),
                      (!_ctx.isEventExhibition(_ctx.eventInformation))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createElementVNode("span", null, null, 512), [
                              [_directive_translate, { key: _ctx.Translation.Date_at_label }]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.eventFromTime) + " ", 1),
                            (_ctx.eventInformation.timezoneOffset)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.eventInformation.startDateTimezoneAbbreviation), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.isEventExhibition(_ctx.eventInformation))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _withDirectives((_openBlock(), _createElementBlock("span", null, [
                              _createTextVNode("to")
                            ])), [
                              [_directive_translate, { key: _ctx.Translation.Date_to_label, lowercase: true }]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.eventToDate), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.schedules !== [] && _ctx.isEventExhibition(_ctx.eventInformation))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.schedules, (schedule, index) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: 'schedule-' + index,
                            class: "o-eventPresentation__schedule"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule['intervals'], (interval, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: 'interval-' + index
                              }, [
                                _createTextVNode(_toDisplayString(interval['from']) + " ", 1),
                                _withDirectives(_createElementVNode("span", null, null, 512), [
                                  [_directive_translate, { key: _ctx.Translation.Date_to_label, lowercase: true }]
                                ]),
                                _createTextVNode(" " + _toDisplayString(interval['to']) + " ", 1),
                                (index !== Object.keys(schedule['intervals']).length - 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" | ")
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            (schedule['days'])
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, " - "))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule['days'], (day, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: 'day-' + index
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.getDaynameFor(day)), 1),
                                (index !== Object.keys(schedule['days']).length - 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(", ")
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_6)
        ])
      ]),
      _hoisted_22
    ])
  ]))
}